import { CityEndpoints } from '@/modules/preference/city/api/cityEndpoints'

/**
 * City endpoint instance
 * instantiate City api class with different api path
 */
export const cityEndpoints = new CityEndpoints('city')
